export default {
  zh: {
    aoName: '我的账号',
    aoServiceTime: '套餐余额',
    aoStTime: '天',
    CNY: '￥',
    D: '天',
    H: '小时',
    m: '分钟',
    aoStNumberDevices: '台',
    aoStInstructions: '订购续费后，服务时长会直接累加',
    inviteFriends: '邀请好友',
    friends: '位',
    irIfInstructions: '邀请更多好友完成注册／充值',
    irInviteRecord: '邀请记录',
    rewards: '奖励天数',
    days: '天',
    irRtInstructions: '好友充值成功，您将获得相应的免费时长奖励',
    commissionReward: '奖励现金',
    withdrawDetails: '提现明细',
    commissionExplain: '好友首次充值，您将获得7%的佣金奖励。',
    withdraw: '申请提现',
    bindPhone: '绑定手机号',
    deviceNum: '设备数量',
    declaration: '订阅声明：',
    declarationList: [
      '可随时取消连续订阅服务，取消后不再自动续费。',
      '连续订阅服务暂只支持 PayPal、信用卡支付方式。'
    ]
  },
  en: {
    aoName: 'My Account',
    aoServiceTime: 'Balance',
    aoStTime: 'Day | Days',
    USD: '$',
    D: 'Day | Days',
    H: 'Hour | Hours',
    m: 'Minute | Minutes',
    aoStNumberDevices: 'Device | Devices',
    aoStInstructions: 'VIP service time will be extended directly after subscription renewal',
    inviteFriends: 'Invite friends',
    friends: 'Friend | Friends',
    irIfInstructions: 'Invite your friends to register / recharge.',
    irInviteRecord: 'Invitation records',
    rewards: 'Rewards',
    days: 'Day | Days',
    irRtInstructions: 'You\'ll get corresponding free service time once your friend successfully purchase a package.',
    commissionReward: 'Rewards',
    withdrawDetails: 'Withdraw Details',
    commissionExplain: 'For every friend who purchases a package for the first time, you’ll get 7% as commission.',
    withdraw: 'Withdraw',
    bindPhone: 'Bind phone',
    deviceNum: 'Device num',
    declaration: 'Subscription Declaration：',
    declarationList: [
      'Recurring subscription service can be canceled at any time, and will not renew automatically once you have canceled it.',
      'The recurring subscription service only supports PayPal and Credit Card payment methods.'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/lang.js